import type linksEn from "./links.en";
const linksFr: Record<keyof typeof linksEn, string> = {
  "admin.links.text0": "Impossible de charger les liens.",
  "admin.links.text1": "Lien désactivé.",
  "admin.links.text2": "Lien réactivé.",
  "admin.links.text3": "Liens courts",
  "admin.links.text4": "Tous les liens créés sur le service",
  "admin.links.text5": "Tous les liens courts",
  "admin.links.text6": "Vue globale des liens créés par les comptes. Un lien abusif peut être désactivé immédiatement.",
  "admin.links.text7": "Actualiser",
  "admin.links.text8": "Rechercher (code, destination, e-mail)",
  "admin.links.text9": "Aucun lien.",
  "admin.links.text10": "Protégé",
  "admin.links.text11": "Désactivé",
  "admin.links.text12": "clic",
  "admin.links.text13": "Activer ou désactiver le lien",
  "admin.links.text14": "Actif",
  "admin.links.text15": "Lien copié.",
  "admin.links.text16": "Copier",
  "admin.links.text17": "/clics",
  "admin.links.text18": "Détail des clics",
  "admin.links.text19": "7 jours",
  "admin.links.text20": "30 jours",
  "admin.links.text21": "90 jours",
  "admin.links.text22": "Tout",
  "admin.links.text23": "Impossible de charger le détail des clics.",
  "admin.links.text24": "Journal complet des clics et regroupement par visiteur",
  "admin.links.text25": "Retour aux liens",
  "admin.links.text26": "Inclure les robots",
  "admin.links.text27": "Robots inclus",
  "admin.links.text28": "Journal",
  "admin.links.text29": "Visiteurs",
  "admin.links.text30": "Chaque clic",
  "admin.links.text31": "Aucun clic sur la période",
  "admin.links.text32": "Rechercher (IP, pays, visiteur, e-mail)",
  "admin.links.text33": "Aucun clic.",
  "admin.links.text34": "Robot",
  "admin.links.text35": "Navigation privée",
  "admin.links.text36": "Appareil inconnu",
  "admin.links.text37": "Source :",
  "admin.links.text38": "Visiteur :",
  "admin.links.text39": " · vérifié",
  "admin.links.text40": "Regroupement par visiteur",
  "admin.links.text41": "Un visiteur = un identifiant Fingerprint (à défaut, empreinte locale ou IP).",
  "admin.links.text42": "Aucun visiteur.",
  "admin.links.text43": "confiance",
  "admin.links.text44": "Pays inconnu",
  "admin.links.text45": "IP :",
  "admin.links.text46": "Rechercher (IP, pays, lien, visiteur, e-mail)",
  "admin.links.text47": "Journal des clics",
  "admin.links.text48": "Qui a cliqué sur les liens",
  "admin.links.text49": "Un visiteur = un identifiant Fingerprint (à défaut, empreinte locale ou IP). Cliquez pour voir sa fiche complète.",
  "admin.links.text50": "Aucun clic sur la période.",
  "admin.links.text51": "Fingerprint vérifié",
  "admin.links.text52": "clic(s) sur la période",
  "admin.links.text53": "Fiche visiteur : liens cliqués, pages vues, appareils et signaux détectés",
  "admin.links.text54": "Lecture impossible :",
  "admin.links.text55": "Aucune donnée.",
  "admin.links.text56": "Identifiants vérifiés",
  "admin.links.text57": "Confiance (dernier événement)",
  "admin.links.text58": "Aucune attribution : aucune connexion authentifiée prouvée ici",
  "admin.links.text59": "Compte prouvé",
  "admin.links.text60": " comptes prouvés (navigateur ou poste partagé)",
  "admin.links.text61": "preuve(s)",
  "admin.links.text62": " · dernière le ",
  "admin.links.text63": "Les comptes restent distincts : aucun regroupement n'est déduit de cette coexistence.",
  "admin.links.text64": "dernier événement daté du",
  "admin.links.text65": "Requête d’identification :",
  "admin.links.text66": "Signaux détaillés de l’empreinte",
  "admin.links.text67": ": les données détaillées ne peuvent pas être reconstituées après coup. L’adresse IP, l’appareil et les pages vues restent disponibles.",
  "admin.links.text68": "Identifiants observés sur ces événements (",
  "admin.links.text69": "Une même adresse IP peut réunir plusieurs navigateurs : chaque identifiant est compté séparément, aucun n’est présenté comme l’identité de toute l’IP.",
  "admin.links.text70": "Adresses IP connues",
  "admin.links.text71": "Liens cliqués (",
  "admin.links.text72": "Aucun clic enregistré.",
  "admin.links.text73": " · requête ",
  "admin.links.text74": "Pages vues (",
  "admin.links.text75": "Aucune page vue associée.",
  "admin.links.text76": "Détail introuvable pour cet événement.",
  "admin.links.text77": "Chargement des signaux…",
  "admin.links.text78": "Erreur :",
  "admin.links.text79": "Aucune observation vérifiée enregistrée pour cet identifiant. Les événements plus anciens n'ont pas été identifiés côté serveur et ne peuvent pas être reconstitués.",
  "admin.links.text80": "Dernier événement vérifié :",
  "admin.links.text81": "· enregistré",
  "admin.links.text82": "observation(s)",
  "admin.links.text83": "Événement historique affiché :",
  "admin.links.text84": "requête",
  "admin.links.text85": "score de suspicion (brut) :",
  "admin.links.text86": "Tableau exhaustif",
  "admin.links.text87": "JSON des produits",
  "admin.links.text88": "événement(s) affiché(s) sur",
  "admin.links.text89": "Charger les",
  "admin.links.text90": "précédent(s)",
  "admin.links.text91": "chargement du détail…",
  "admin.links.text92": "sources :",
  "admin.links.text93": "Erreur de chargement du détail :",
  "admin.links.text94": "Chargement des signaux de l’événement sélectionné… (les signaux affichés ci-dessous ne sont jamais ceux d’un autre événement)",
  "admin.links.text95": "signal mobile",
  "admin.links.text96": "valeur lue dans",
  "admin.links.text97": "Fenêtres de vélocité",
  "admin.links.text98": "VPN · confiance",
  "admin.links.text99": "fuseau d'origine :",
  "admin.links.text100": "pays d'origine :",
  "admin.links.text101": "Changements entre observations",
  "admin.links.text102": "Tableau exhaustif des signaux",
  "admin.links.text103": "Rechercher un champ ou une valeur…",
  "admin.links.text104": "champ(s) · événement du",
  "admin.links.text105": "· source",
  "admin.links.text106": "Champ",
  "admin.links.text107": "Valeur",
  "admin.links.text108": "Produit",
  "admin.links.text109": "Exclusion annulée",
  "admin.links.text110": "Sélectionnez au moins 2 empreintes.",
  "admin.links.text111": "Exclusion annulée.",
  "admin.links.text112": "Relevé introuvable pour cette preuve.",
  "admin.links.text113": "Chargement des regroupements…",
  "admin.links.text114": "Comptes associés (connexion authentifiée)",
  "admin.links.text115": "Aucun compte associé : ce navigateur n'a jamais prouvé de connexion authentifiée.",
  "admin.links.text116": "Plusieurs comptes se sont connectés depuis ce navigateur : il s'agit probablement d'un navigateur partagé. Les comptes restent distincts et ne sont jamais fusionnés.",
  "admin.links.text117": "Annuler l’exclusion",
  "admin.links.text118": "Exclure",
  "admin.links.text119": "première association",
  "admin.links.text120": "· dernière",
  "admin.links.text121": "preuves :",
  "admin.links.text122": "Ouvrir le relevé complet de cette preuve",
  "admin.links.text123": "sur",
  "admin.links.text124": "Précédents",
  "admin.links.text125": "Suivants",
  "admin.links.text126": "Journal des exclusions",
  "admin.links.text127": "Aucune exclusion enregistrée pour ce navigateur.",
  "admin.links.text128": "· compte :",
  "admin.links.text129": "· motif :",
  "admin.links.text130": "· par",
  "admin.links.text131": "Même compte · autres navigateurs",
  "admin.links.text132": "Aucun autre navigateur prouvé sur ces comptes.",
  "admin.links.text133": "Empreintes similaires (90 jours, aucun regroupement automatique)",
  "admin.links.text134": "Aucune empreinte similaire sur cette période.",
  "admin.links.text135": "famille(s) concordante(s)",
  "admin.links.text136": "événement(s) · dernier",
  "admin.links.text137": "Preuves détaillées",
  "admin.links.text138": "concordances :",
  "admin.links.text139": "· informations absentes :",
  "admin.links.text140": "appareils :",
  "admin.links.text141": "· langues :",
  "admin.links.text142": "· fuseau du réseau :",
  "admin.links.text143": "· fuseau d’origine déclaré :",
  "admin.links.text144": "· IP :",
  "admin.links.text145": "· liens :",
  "admin.links.text146": "navigateur(s) en commun (information, non compté dans le score) :",
  "admin.links.text147": "page",
  "admin.links.text148": "Précédentes",
  "admin.links.text149": "Suivantes",
  "admin.links.text150": "Comparaison côte à côte (2 à 4 empreintes, similaires ou non)",
  "admin.links.text151": "Ajouter un identifiant de navigateur…",
  "admin.links.text152": "Ajouter",
  "admin.links.text153": "Comparer la sélection (",
  "admin.links.text154": "Indice",
  "admin.links.text155": "Fuseau du réseau (IP)",
  "admin.links.text156": "Fuseau d’origine déclaré",
  "admin.links.text157": "Liens consultés",
  "admin.links.text158": "Comptes prouvés",
  "admin.links.text159": "Identifiants de requête",
  "admin.links.text160": "Événements",
  "admin.links.text161": "Sans événement vérifié sur la période :",
  "admin.links.text162": "Preuves du rapprochement",
  "admin.links.text163": "Différences et absences",
  "admin.links.text164": "Relevé de la preuve de connexion",
  "admin.links.text165": "compte :",
  "admin.links.text166": "· requête :",
  "admin.links.text167": "Chargement du relevé…",
  "admin.links.text168": "Exclure l’association",
  "admin.links.text169": "Compte :",
  "admin.links.text170": ". L’exclusion est réversible et enregistrée dans le journal.",
  "admin.links.text171": "Motif (facultatif)",
  "admin.links.text172": "Annuler",
  "admin.links.text173": "Aucun identifiant sur ces événements",
  "admin.links.text174": "identifiant(s) Fingerprint ·",
  "admin.links.text175": "vérifié(s)",
  "admin.links.text176": " événement(s)",
  "admin.links.text177": "VPN",
  "admin.links.text178": "Proxy",
  "admin.links.text179": "Tor",
  "admin.links.text180": "Aucune identification reçue",
  "admin.links.text181": "Vérification non configurée",
  "admin.links.text182": "Erreur de vérification",
  "admin.links.text183": "Vérification injoignable",
  "admin.links.text184": "Vérification expirée",
  "admin.links.text185": "Identification périmée",
  "admin.links.text186": "Réponse inexploitable",
  "admin.links.text187": "Identifié côté navigateur, non vérifié",
  "admin.links.text188": "Clé navigateur absente",
  "admin.links.text189": "Agent non chargé côté navigateur",
  "admin.links.text190": "Identification en échec côté navigateur",
  "admin.links.text191": "Identification expirée côté navigateur",
  "admin.links.text192": "Navigateur sans identifiant de requête",
  "admin.links.text193": "État inconnu",
  "admin.links.text194": "détecté",
  "admin.links.text195": "non détecté",
  "admin.links.text196": "non fourni pour cet événement",
  "admin.links.text197": "Réseau",
  "admin.links.text198": "Activité",
  "admin.links.text199": "Appareil",
  "admin.links.text200": "Robot (botd)",
  "admin.links.text201": "Localisation falsifiée",
  "admin.links.text202": "Attaque de l’intermédiaire",
  "admin.links.text203": "Proximité",
  "admin.links.text204": "Falsification du navigateur",
  "admin.links.text205": "Outils de développement",
  "admin.links.text206": "Application clonée",
  "admin.links.text207": "Réinitialisation d’usine",
  "admin.links.text208": "Vélocité",
  "admin.links.text209": "Activité élevée",
  "admin.links.text210": "Émulateur",
  "admin.links.text211": "Appareil débridé",
  "admin.links.text212": "Paramètres de confidentialité",
  "admin.links.text213": "Détecté",
  "admin.links.text214": "Non détecté",
  "admin.links.text215": "Erreur du fournisseur",
  "admin.links.text216": "Renseigné",
  "admin.links.text217": "Non fourni pour cet événement",
  "admin.links.text218": "Identifiant du navigateur",
  "admin.links.text219": "Identifiant de la requête",
  "admin.links.text220": "Navigateur déjà connu",
  "admin.links.text221": "Confiance",
  "admin.links.text222": "Première apparition",
  "admin.links.text223": "Dernière apparition",
  "admin.links.text224": "Navigateur",
  "admin.links.text225": "Version du navigateur",
  "admin.links.text226": "Système",
  "admin.links.text227": "Version du système",
  "admin.links.text228": "Ville",
  "admin.links.text229": "Pays",
  "admin.links.text230": "Régions",
  "admin.links.text231": "Rayon de précision",
  "admin.links.text232": "Réseau (ASN)",
  "admin.links.text233": "Plage réseau",
  "admin.links.text234": "Centre de données",
  "admin.links.text235": "Page",
  "admin.links.text236": "Étiquette",
  "admin.links.text237": "Identifiant lié",
  "admin.links.text238": "Résultat",
  "admin.links.text239": "Navigateur anti-détection",
  "admin.links.text240": "Score du modèle",
  "admin.links.text241": "Détails",
  "admin.links.text242": "Requêtes du jour",
  "admin.links.text243": "Pays d’origine déclaré",
  "admin.links.text244": "Méthodes",
  "admin.links.text245": "Compte inconnu",
  "admin.links.text246": "inconnu",
  "admin.links.text247": "Falsification",
  "admin.links.text248": "Machine virtuelle",
  "admin.links.text249": "Identification",
  "admin.links.text250": "Risque",
  "admin.links.text251": "Autres produits",
  "admin.links.text252": "Informations IP",
  "admin.links.text253": "IP en liste noire",
  "admin.links.text254": "Score de suspicion",
  "admin.links.text255": "Frida",
  "admin.links.text256": "Applications root",
  "admin.links.text257": "Attributs de l’appareil",
  "admin.links.text258": "Adresse IP",
  "admin.links.text259": "Agent utilisateur",
  "admin.links.text260": "Fuseau horaire",
  "admin.links.text261": "Nom",
  "admin.links.text262": "Latitude",
  "admin.links.text263": "Longitude",
  "admin.links.text264": "Code postal",
  "admin.links.text265": "Score d’anomalie",
  "admin.links.text266": "[valeur illisible]",
  "admin.links.text267": "non fourni",
  "admin.links.text268": "Exclusion",
  "admin.links.text269": "Association",
  "admin.links.text270": "Clics",
  "admin.links.text271": "Clics de liens",
  "admin.links.text272": "Pages vues",
  "admin.links.text273": "Adresses IP",
  "admin.links.text274": "Visiteurs distincts",
  "admin.links.text275": "Humains",
  "admin.links.text276": "Robots",
  "admin.links.text277": "Comptes reconnus",
  "admin.links.text278": "7 j",
  "admin.links.text279": "30 j",
  "admin.links.text280": "90 j",
  "admin.links.text281": "12 mois",
  "admin.links.text282": "exclue",
  "admin.links.text283": "Clics de /{v0}",
  "admin.links.text284": "Du {v0} au {v1}",
  "admin.links.text285": " · confiance {v0}%",
  "admin.links.text286": "{v0} comptes prouvés (navigateur ou poste partagé)",
  "admin.links.text287": " · dernière le {v0}",
  "admin.links.text288": "{v0} preuve(s)",
  "admin.links.text289": " · motif : {v0}",
  "admin.links.text290": "Comparer {v0}",
  "admin.links.text291": " · {v0} local (bv_)",
  "admin.links.text292": "{v0} · {v1}{v2} · {v3} événement(s)"
};
export default linksFr;
